import axiosNest from '../../api/axiosNest';

/**
 * „Moje konta giełdowe” — konto imienne tradera do TIMOCOM i Trans.eu
 * (odpowiedzi Marathonu/Euvic 16.10.2026, pyt. 18a: „konto tradera
 * imienne”). Odpowiada `apps/api/src/postings/personal-accounts.controller.ts`;
 * za przełącznikiem `exchangePersonalAccount` (wyłączony — API 404).
 *
 * **Tylko zapis.** API nie oddaje wartości nigdy — tylko, które pola są
 * zapisane i kiedy. Trasa nie przyjmuje identyfikatora konta: bierze go
 * z tokenu.
 */

export const MY_EXCHANGE_ACCOUNTS_URL = '/exchange-accounts/mine';

export interface MyExchangeAccountField {
  field: string;
  label: string;
  saved: boolean;
  updatedAt: string | null;
}

export interface MyExchangeAccount {
  exchange: string;
  label: string;
  fields: MyExchangeAccountField[];
  complete: boolean;
  /** Co zostaje przy spółce (Trans.eu: klucze aplikacji). */
  companyNote: string | null;
}

export async function fetchMyExchangeAccounts(): Promise<MyExchangeAccount[]> {
  const { data } = await axiosNest.get(MY_EXCHANGE_ACCOUNTS_URL);
  return Array.isArray(data) ? data : [];
}

/** Zapis wypełnionych pól; puste pola nie idą (serwer: „bez zmian”). */
export async function saveMyExchangeAccount(
  exchange: string,
  values: Record<string, string>,
): Promise<MyExchangeAccount[]> {
  const filled = Object.fromEntries(Object.entries(values).filter(([, v]) => v !== ''));
  const { data } = await axiosNest.put(`${MY_EXCHANGE_ACCOUNTS_URL}/${exchange}`, { values: filled });
  return Array.isArray(data) ? data : [];
}

export async function removeMyExchangeAccount(exchange: string): Promise<MyExchangeAccount[]> {
  const { data } = await axiosNest.delete(`${MY_EXCHANGE_ACCOUNTS_URL}/${exchange}`);
  return Array.isArray(data) ? data : [];
}
